import React, { useState,useEffect } from "react";
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import WhatsAppButton from './whatsapp';
import Chat from './chat';
import {Helmet} from 'react-helmet';
import Marquee from './marquee';


const Blogin = () => {
  const [open, setOpen] = useState(false);
    const [latest,setlatest]=useState([]);
    const [aboutus,setaboutus]=useState([]);
      const [qa,setqa]=useState([]);
       const [news,setnews]=useState([]);
   
    useEffect(()=>{
        const fetchlatest=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/latest`);
     setlatest(res.data);
      }catch(error){
      console.error(error);
      }
    }
     const fetchQa=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/qa`);
     
     setqa(res.data);
      }catch(error){
      console.error(error);
      }
    }
    const fetchnews=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/news`);
     
     setnews(res.data);
      }catch(error){
      console.error(error);
      }
    }
    const fetchAbout=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/blog`);
     setaboutus(res.data);
      }catch(error){
      console.error(error);
      }
    }
    fetchAbout();
    fetchlatest();
     fetchQa();
    fetchnews();
    },[]);


  return (
    <>
    <div className="app">
      <Header />
      <Marquee/>
   <Helmet>
            <title>Pranati Interior - Kolkata best Interior</title>
            <meta name="description" content="Welcome to Kolkata best interior" />
    
            <link rel="canonical" href="https://squareandangle.pranatigroup.in/blogin" />
    
            <meta property="og:title" content="Pranati interior" />
            <meta property="og:description" content="Kolkata best Interior" />
            <meta property="og:image" content="/images/preview.png" />
            <meta property="og:url" content="https://squareandangle.pranatigroup.in/blogin" />
    
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Pranati interior" />
            <meta name="twitter:description" content="Kolkata best Interior" />
            <meta name="twitter:image" content="/images/preview.png" />
    
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Pranati Interior",
                "url": "https://squareandangle.pranatigroup.in/blogin",
                "description": "Kolkata best Interior",
                "image": "https://squareandangle.pranatigroup.in/images/preview.png",
                "areaServed": "Kolkata",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Kolkata",
                  "addressRegion": "West Bengal",
                  "addressCountry": "IN"
                }
              })}
            </script>
          </Helmet>
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>Blog</h2>
                        <ul>
                            <li><a href="index.html">Home</a></li>
                            <li>/</li>
                            <li>Blog</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
  <div
  style={{
    padding: "80px 0",
    background: "#fff",
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "0 15px",
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: "28px",
      }}
      className="blog-grid"
    >
      {aboutus.map((item, index) => (
        <article
          key={item.id || index}
          style={{
            background: "#fff",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid #eeeeee",
            boxShadow: "0 8px 30px rgba(0,0,0,0.07)",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {/* Image */}
          <div
            style={{
              width: "100%",
              height: "220px",
              overflow: "hidden",
              background: "#eee",
            }}
          >
            <img
              src={uploadUrl(item.blogs_images)}
              alt={item.title || "Interior designs Kolkata"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>

          {/* Content */}
          <div
            style={{
              padding: "22px",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >
            {item.blogs_text && (
              <div
                style={{
                  color: "#b08d57",
                  fontSize: "12px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  marginBottom: "9px",
                }}
              >
                {item.blogs_text}
              </div>
            )}

            <h3
              style={{
                color: "#222",
                fontSize: "19px",
                lineHeight: "1.4",
                fontWeight: "600",
                margin: "0 0 10px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {item.title}
            </h3>

            <p
              style={{
                color: "#777",
                fontSize: "14px",
                lineHeight: "1.7",
                margin: "0 0 20px",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {item.blog_description}
            </p>

            
          </div>
        </article>
      ))}
    </div>
  </div>

  <style>
    {`
      @media (max-width: 991px) {
        .blog-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 20px !important;
        }
      }

      @media (max-width: 575px) {
        .blog-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 12px !important;
        }

        .blog-grid article > div:first-child {
          height: 130px !important;
        }

        .blog-grid article > div:nth-child(2) {
          padding: 13px !important;
        }

        .blog-grid h3 {
          font-size: 14px !important;
        }

        .blog-grid p {
          font-size: 12px !important;
          line-height: 1.5 !important;
        }

        .blog-grid a {
          font-size: 11px !important;
        }
      }
    `}
  </style>
</div>

   
    

   
<div className="row">
    {/* LEFT - FAQ */}
    <div className="col-lg-6 col-md-6 col-12">
        <div
            className="widget pranati-qa-widget"
            style={{
                width: "100%",
                margin: "35px 0 0",
                background: "linear-gradient(145deg, #fff8f2, #f8f3ff)",
                padding: "24px",
                borderRadius: "16px",
                boxShadow: "0 10px 30px rgba(80, 50, 110, 0.12)",
                border: "1px solid #eadff0",
                boxSizing: "border-box",
            }}
        >
            <h3
                style={{
                    fontSize: "21px",
                    fontWeight: "800",
                    color: "#43265d",
                    margin: "0 0 16px",
                    paddingBottom: "12px",
                    borderBottom: "2px solid #e99a68",
                }}
            >
                <span style={{ color: "#e4774d" }}>Pranati</span> Interior Q & A
            </h3>

            {qa.map((item, index) => (
                <details
                    key={index}
                    style={{
                        borderBottom: "1px solid #eadfea",
                    }}
                >
                    <summary
                        style={{
                            listStyle: "none",
                            cursor: "pointer",
                            padding: "15px 38px 15px 0",
                            position: "relative",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#33263d",
                            lineHeight: "1.55",
                        }}
                    >
                        <span
                            className="number-badge"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                                borderRadius: "8px",
                                background:
                                    index % 2 === 0
                                        ? "#e98255"
                                        : "#8060b5",
                                color: "#fff",
                                fontSize: "11px",
                                fontWeight: "800",
                                verticalAlign: "middle",
                            }}
                        >
                            {String(index + 1).padStart(2, "0")}
                        </span>

                        {item.question}

                        <span
                            className="faq-icon"
                            style={{
                                position: "absolute",
                                right: "0",
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                background: "#fff",
                                border: "1px solid #dfd3e8",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#765394",
                                fontSize: "17px",
                            }}
                        >
                            +
                        </span>
                    </summary>

                    <div
                        style={{
                            marginBottom: "12px",
                            padding: "12px 14px",
                            borderRadius: "10px",
                            background: "rgba(255,255,255,0.8)",
                            borderLeft: "3px solid #e98255",
                            color: "#6b6170",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        <span
                            style={{
                                color: "#765394",
                                fontWeight: "700",
                                marginRight: "5px",
                            }}
                        >
                            {new Date().getFullYear()}
                        </span>

                        {item.answer}
                    </div>
                </details>
            ))}
        </div>
    </div>

    {/* RIGHT - RECENT NEWS ACCORDION */}
    <div className="col-lg-6 col-md-6 col-12">
        <div
            className="widget recent-news-widget"
            style={{
                width: "100%",
                margin: "35px 0 0",
                background:
                    "linear-gradient(145deg, #f7f1ff 0%, #ffffff 50%, #fff8f2 100%)",
                padding: "24px",
                borderRadius: "16px",
                boxShadow: "0 10px 30px rgba(80, 50, 110, 0.12)",
                border: "1px solid #eadff0",
                boxSizing: "border-box",
            }}
        >
            <h3
                style={{
                    fontSize: "21px",
                    fontWeight: "800",
                    color: "#43265d",
                    margin: "0 0 16px",
                    paddingBottom: "12px",
                    borderBottom: "2px solid #8060b5",
                }}
            >
                <span style={{ color: "#8060b5" }}>Recent</span> News
            </h3>

            {news.map((item, index) => (
                <details
                    key={index}
                    style={{
                        borderBottom: "1px solid #eadfea",
                    }}
                >
                    <summary
                        style={{
                            listStyle: "none",
                            cursor: "pointer",
                            padding: "15px 38px 15px 0",
                            position: "relative",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#33263d",
                            lineHeight: "1.55",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                                borderRadius: "8px",
                                background:
                                    index % 2 === 0
                                        ? "linear-gradient(135deg, #8060b5, #69499b)"
                                        : "linear-gradient(135deg, #e98255, #e4774d)",
                                color: "#fff",
                                fontSize: "11px",
                                fontWeight: "800",
                                verticalAlign: "middle",
                            }}
                        >
                            {String(index + 1).padStart(2, "0")}
                        </span>

                        {item.question}?

                        <span
                            className="news-icon"
                            style={{
                                position: "absolute",
                                right: "0",
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                background: "#fff",
                                border: "1px solid #dfd3e8",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#765394",
                                fontSize: "17px",
                            }}
                        >
                            +
                        </span>
                    </summary>

                    {/* CLICK OPEN ANSWER */}
                    <div
                        style={{
                            marginBottom: "12px",
                            padding: "12px 14px",
                            borderRadius: "10px",
                            background: "rgba(255,255,255,0.85)",
                            borderLeft: "3px solid #8060b5",
                            color: "#6b6170",
                            fontSize: "13px",
                            lineHeight: "1.7",
                        }}
                    >
                        <span
                            style={{
                                color: "#8060b5",
                                fontWeight: "700",
                                marginRight: "5px",
                            }}
                        >
                            {new Date().getFullYear()}
                        </span>

                        {item.answer}.
                    </div>
                </details>
            ))}

            {/* EXTRA NEWS ITEM */}
            <details>
                <summary
                    style={{
                        listStyle: "none",
                        cursor: "pointer",
                        padding: "15px 38px 10px 0",
                        position: "relative",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#33263d",
                        lineHeight: "1.55",
                    }}
                >
                    <span
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            marginRight: "10px",
                            borderRadius: "8px",
                            background:
                                "linear-gradient(135deg, #e98255, #e4774d)",
                            color: "#fff",
                            fontSize: "15px",
                            fontWeight: "800",
                            verticalAlign: "middle",
                        }}
                    >
                        +
                    </span>

                    How can I make interior design of my home?

                    <span
                        style={{
                            position: "absolute",
                            right: "0",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "26px",
                            height: "26px",
                            borderRadius: "50%",
                            background: "#fff",
                            border: "1px solid #dfd3e8",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#765394",
                            fontSize: "17px",
                        }}
                    >
                        +
                    </span>
                </summary>

                <div
                    style={{
                        marginBottom: "5px",
                        padding: "12px 14px",
                        borderRadius: "10px",
                        background: "rgba(255,255,255,0.85)",
                        borderLeft: "3px solid #e98255",
                        color: "#6b6170",
                        fontSize: "13px",
                        lineHeight: "1.7",
                    }}
                >
                    Learn more about creating a beautiful and functional
                    interior design for your home.
                </div>
            </details>
        </div>
    </div>

    <style>
        {`
            .pranati-qa-widget details summary::-webkit-details-marker,
            .recent-news-widget details summary::-webkit-details-marker {
                display: none;
            }

            .pranati-qa-widget details summary:hover,
            .recent-news-widget details summary:hover {
                color: #765394 !important;
            }

            .pranati-qa-widget details[open] .faq-icon,
            .recent-news-widget details[open] .news-icon {
                background: #765394 !important;
                color: #fff !important;
                border-color: #765394 !important;
                transform: translateY(-50%) rotate(45deg) !important;
            }

            @media (max-width: 767px) {
                .pranati-qa-widget,
                .recent-news-widget {
                    margin-top: 25px !important;
                }
            }
        `}
    </style>
</div>


    

   
   
    <Footer />
    {open && (
      <div style={styles.overlay} onClick={()=>setOpen(false)}>
        <div style={styles.modal} >
          <h2 style={{marginBottom: "20px"}}>Get Free Quote</h2>
          <div style={styles.inputBox}>
            <input type="text" placeholder="Name" />
          </div>
          <div style={styles.inputBox}>
            <input type="text" placeholder="Phone" />
          </div>
          <div style={styles.inputBox}>
            <input type="email" placeholder="Email" />
          </div>
          <label style={{ display: "block", margin: "10px 0" }}>
            <input type="checkbox" defaultChecked />
            Send me updates on WhatsApp
          </label>
          <button style={styles.submitButton}>GET FREE QUOTE</button>
          <button style={styles.closeButton} onClick={()=>setOpen(false)}>Close</button>
        </div>
      </div>
    )}
    </div>
    </>
  );
};


const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
  },
  inputBox: {
    marginBottom: "15px"
  },
  submitButton: {
    width: "100%",
    padding: "12px",
    background: "#e85d5d",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "10px"
  },
  closeButton: {
    width: "100%",
    padding: "10px",
    background: "#ccc",
    color: "#333",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px"
  }
};

export default Blogin;